module.exports = __webpack_public_path__ + "static/media/ic-orange-clock.2d90a802.svg";